import { authFetch } from "../utils/authFetch"
import { API_BASE_URL } from "../config"
const baseUrl = `${API_BASE_URL}/tarifa`

export const getTiposTarifa = async () => {
  const response = await authFetch(`${API_BASE_URL}/tipoTarifa/listar`, {
    method: "GET",
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al consultar los tipos de tarifa: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

export const getTiposTarifaPorSucursal = async (idSucursal) => {
  const response = await authFetch(`${baseUrl}/sucursal/${idSucursal}/tipos-tarifa`, {
    method: "GET",
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al consultar los tipos de tarifa por sucursal: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

export const getTarifas = async () => {
  const response = await authFetch(`${baseUrl}/listar-detallado`, {
    method: "GET",
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al consultar las tarifas: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

export const createTarifa = async (tarifaData) => {
  const response = await authFetch(`${baseUrl}/crear`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(tarifaData),
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al crear la tarifa: ${errorText || "Sin detalles"}`)
  }

  const contentType = response.headers.get("Content-Type")
  if (contentType && contentType.includes("application/json")) {
    return response.json()
  } else {
    return { success: true }
  }
}

export const updateTarifa = async (id, tarifaData) => {
  const response = await authFetch(`${baseUrl}/modificar/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(tarifaData),
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al actualizar la tarifa: ${errorText || "Sin detalles"}`)
  }

  const contentType = response.headers.get("Content-Type")
  if (contentType && contentType.includes("application/json")) {
    return response.json()
  } else {
    return { success: true }
  }
}

export const deleteTarifa = async (id) => {
  const response = await authFetch(`${baseUrl}/eliminar/${id}`, {
    method: "DELETE",
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al eliminar la tarifa: ${errorText || "Sin detalles"}`)
  }

  const contentType = response.headers.get("Content-Type")
  if (contentType && contentType.includes("application/json")) {
    console.log("Respuesta con JSON recibida en deleteTarifa")
    return response.json()
  } else {
    console.log("Respuesta sin JSON en deleteTarifa, asumiendo éxito")
    return { success: true }
  }
}
